import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationMessages } from 'constants/validation'

import { Stack, TextField } from '@mui/material'
import { Section } from 'components/controls/section'

import { KojinMatchingFormData } from "interface/kojin/match"

const {
  Required
} = validationMessages

const formSchema = yup.object().shape({
	name: yup.string().required(Required),
	affiliation: yup.string().nullable()
})

type useKojinSelfMatchingFormProps = {
	formData: KojinMatchingFormData
	onSubmit: (formData: KojinMatchingFormData) => void
}
export const useKojinSelfMatchingForm = ({
	formData,
	onSubmit
}: useKojinSelfMatchingFormProps) => {
	const form = useForm({
		defaultValues: {
			name: formData.name,
			affiliation: formData.affiliation ?? ''
		},
		mode: 'onChange',
		resolver: yupResolver(formSchema)
	})
	return {
		...form,
    submit: form.handleSubmit(input => onSubmit({
			...formData,
			name: input.name,
			affiliation: input.affiliation
		}))
	}
}

export const KojinSelfMatchingForm = ({
	control,
	formState: { errors }
}: ReturnType<typeof useKojinSelfMatchingForm>) => {
	return (
		<Stack direction="column">
			<Section label="医師名" labelProps={{ paddingY: 2 }}>
				<Controller
					control={control}
					name="name"
					render={({ field }) => (
						<>
							<TextField
								{...field}
								variant="outlined"
								size="small"
								error={!!errors.name}
								helperText={errors.name ? errors.name.message : ''}
							/>
						</>
					)}
				/>
			</Section>

			<Section label="所属" labelProps={{ py: 2 }}>
				<Controller
					control={control}
					name="affiliation"
					render={({ field }) => (
						<TextField
							{...field}
							variant="outlined"
							fullWidth
							multiline
							rows={3}
							error={!!errors.affiliation}
							helperText={errors.affiliation ? errors.affiliation.message : ''}
						/>
					)}
				/>
			</Section>
		</Stack>
	)
}